"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var base_data_mapper_1 = __importDefault(require("./base_data_mapper"));
var string_utils_1 = __importDefault(require("./string_utils"));
var get_items_result_1 = __importDefault(require("./get_items_result"));
var remote_exception_1 = __importDefault(require("./remote_exception"));
var RemoteDataMapper = /** @class */ (function (_super) {
    __extends(RemoteDataMapper, _super);
    function RemoteDataMapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Execute DELETE web method
     * @param key - resource key
     */
    RemoteDataMapper.prototype.delete = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var url, requestConfig, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.url;
                        if (!string_utils_1.default.stringIsNullOrEmpty(key)) {
                            url = string_utils_1.default.concat(this.url, '/', key);
                        }
                        requestConfig = {
                            url: url,
                            method: 'DELETE'
                        };
                        return [4 /*yield*/, this.sendRequest(requestConfig)];
                    case 1:
                        response = _a.sent();
                        this.raiseExceptionIfNeed(response);
                        return [2 /*return*/, true];
                }
            });
        });
    };
    /**
     * Execute GET web method for single resource
     * @param key - resource key
     */
    RemoteDataMapper.prototype.getItem = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var url, requestConfig, response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.url;
                        if (!string_utils_1.default.stringIsNullOrEmpty(key)) {
                            url = string_utils_1.default.concat(this.url, '/', key);
                        }
                        requestConfig = {
                            url: url,
                            method: 'GET'
                        };
                        return [4 /*yield*/, this.sendRequest(requestConfig)];
                    case 1:
                        response = _a.sent();
                        this.raiseExceptionIfNeed(response);
                        data = response.data;
                        if (data != null) {
                            return [2 /*return*/, this.map(data)];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    /**
     * Execute GET web method for resources
     * @param filter - query filter
     */
    RemoteDataMapper.prototype.getItems = function (filter) {
        return __awaiter(this, void 0, void 0, function () {
            var requestConfig, response, result, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestConfig = __assign({ url: this.url, method: 'GET' }, filter);
                        return [4 /*yield*/, this.sendRequest(requestConfig)];
                    case 1:
                        response = _a.sent();
                        this.raiseExceptionIfNeed(response);
                        result = new get_items_result_1.default();
                        if (response) {
                            data = response.data;
                            if (null != data) {
                                result.collection = this.convertCollection(data.results); //TODO для разных сервисов разный формат
                                result.totalCount = data.count; //TODO для разных сервисов разный формат
                            }
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Execute POST web method for new resource
     * @param payload - new resource data
     */
    RemoteDataMapper.prototype.insert = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var requestConfig, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestConfig = __assign({ url: this.url, method: 'POST' }, payload);
                        return [4 /*yield*/, this.sendRequest(requestConfig)];
                    case 1:
                        response = _a.sent();
                        this.raiseExceptionIfNeed(response);
                        return [2 /*return*/, this.map(response.data)];
                }
            });
        });
    };
    /**
     * Execute PUT web method for update resource
     * @param key - resource key
     * @param payload - new resource data
     */
    RemoteDataMapper.prototype.update = function (key, payload) {
        return __awaiter(this, void 0, void 0, function () {
            var url, requestConfig, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.url;
                        if (!string_utils_1.default.stringIsNullOrEmpty(key)) {
                            url = string_utils_1.default.concat(this.url, '/', key);
                        }
                        requestConfig = __assign({ url: url, method: 'PUT' }, payload);
                        return [4 /*yield*/, this.sendRequest(requestConfig)];
                    case 1:
                        response = _a.sent();
                        this.raiseExceptionIfNeed(response);
                        return [2 /*return*/, true];
                }
            });
        });
    };
    RemoteDataMapper.prototype.raiseExceptionIfNeed = function (response) {
        if (response.status >= 400 && response.status < 500) {
            var ex = new remote_exception_1.default("Client error");
            ex.response = response;
            throw ex;
        }
        else if (response.status >= 500) {
            var ex = new remote_exception_1.default("Internal server error");
            ex.response = response;
            throw ex;
        }
    };
    RemoteDataMapper.prototype.sendRequest = function (requestConfig) {
        if (null == requestConfig) {
            throw new remote_exception_1.default("Axios request config is null");
        }
        requestConfig.baseURL = RemoteDataMapper.baseURL;
        var url = requestConfig.url == undefined ? '' : requestConfig.url;
        var method = requestConfig.method == undefined ? '' : requestConfig.method;
        if (string_utils_1.default.stringIsNullOrEmpty(url)) {
            throw new remote_exception_1.default("URL is null or empty");
        }
        if (string_utils_1.default.stringIsNullOrEmpty(method)) {
            throw new remote_exception_1.default("HTTP method is null or empty");
        }
        method = method.toLocaleUpperCase();
        var response;
        if (method == 'GET') {
            response = axios_1.default.get(url, requestConfig);
        }
        else if (method == 'DELETE') {
            response = axios_1.default.delete(url, requestConfig);
        }
        else if (method == 'POST') {
            response = axios_1.default.post(url, requestConfig.data, requestConfig);
        }
        else if (method == 'PUT') {
            response = axios_1.default.put(url, requestConfig.data, requestConfig);
        }
        else {
            throw new Error("Not implemented error");
        }
        return response;
    };
    return RemoteDataMapper;
}(base_data_mapper_1.default));
exports.default = RemoteDataMapper;
//# sourceMappingURL=remote_data_mapper.js.map